"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Service_1 = __importDefault(require("../Service"));
var utils_1 = require("../utils");
var BidService = /** @class */ (function (_super) {
    __extends(BidService, _super);
    function BidService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BidService.createBid = function (accountId, body) {
        return this.Http.post("/bids/".concat(accountId), body)
            .then(this.getData);
    };
    BidService.getAllBids = function (query) {
        var queryString = (0, utils_1.generateQueryString)(query);
        var uri = '/bids'.concat(queryString);
        return this.Http.get(uri)
            .then(this.getData);
    };
    BidService.getBidById = function (bidId) {
        return this.Http.get("/bids/".concat(bidId))
            .then(this.getData);
    };
    BidService.BidUpdate = function (bidId, data) {
        return this.Http.put("/bids/".concat(bidId), data)
            .then(this.getData);
    };
    BidService.getBidDailyNumber = function () {
        return this.Http.get('/bids/dashboards/daily-records')
            .then(this.getData);
    };
    BidService.getBidNumber = function () {
        return this.Http.get('/bids/dashboards/records')
            .then(this.getData);
    };
    BidService.getBidPercentage = function (side) {
        return this.Http.get('/bids/dashboards/products-percentage', {
            params: {
                side: side
            }
        })
            .then(this.getData);
    };
    BidService.getBidsNearby = function (bidId) {
        return this.Http.get("/bids/bids-nearby/".concat(bidId))
            .then(this.getData);
    };
    BidService.getBidsSite = function (query) {
        var queryString = (0, utils_1.generateQueryString)(query);
        return this.Http.get('/bids/site'.concat(queryString))
            .then(this.getData);
    };
    BidService.inactiveBid = function (bidId) {
        return this.Http.put("/bids/inactivate/".concat(bidId))
            .then(this.getData);
    };
    BidService.restoreBid = function (bidId) {
        return this.Http.put("/bids/restore/".concat(bidId))
            .then(this.getData);
    };
    return BidService;
}(Service_1.default));
exports.default = BidService;
